export const paths = {
  home: "/",
  login: {
    index: "/login",
  },
  dashboard: {
    index: "/dashboard",
  },
};
